import React from "react";

interface Props {
  block: boolean;
}

export default function ContainerBlocker({ block }: Props) {
  return <div className={`absolute w-full h-full bg-gray-300 opacity-40 ${!block && "hidden"}`} />;
}
